module.exports = __webpack_public_path__ + "static/dc-nordeste-3-c2301ed5191c27aec441e57f50b4e539.jpg";